import React from "react";

function Navlinks() {
  return (
    <ul className="navLinksContainer">
      <a
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
        className="navLinks"
      >
        <li>about</li>
      </a>
      <a
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
        className="navLinks"
      >
        <li>how it works</li>
      </a>
      <a
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
        className="navLinks"
      >
        <li>pricing</li>
      </a>
      <a
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
        className="navLinks"
      >
        <li>solution</li>
      </a>
      <a
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
        className="navLinks"
      >
        <li>features</li>
      </a>
    </ul>
  );
}

export default Navlinks;
